// @flow

import _ from 'lodash';
import { RestApi } from 'app/rgs/api';

const BASE_URL = ['lk', 'profiles', 'my', 'menu'];

const api = new RestApi();

const normalizeMenuItems = response => {
	const { Data } = response || {};

	return { Items: Data || [] };
};

const fetchMenuItems = _.memoize(
	() => api.my.get(BASE_URL).then(normalizeMenuItems)
);

export default {
	fetchMenuItems,
};
